/**
 * Alt-Varianten (Archiv) — Legacy-JSON products.variants, nur lesend.
 * Wird nie geschrieben; Bestände laufen über product_variants / Stock-Engine.
 */
import { Archive } from 'lucide-react';
import { parseArrayField } from '@/lib/jsonField';
import { Section } from './EditorPrimitives';

export default function ProductEditorArchiv({ product }) {
  const legacy = parseArrayField(product?.variants, { fieldName: 'variants' });
  if (legacy.length === 0) return null;
  return (
    <Section icon={Archive} title={`Alt-Varianten (Archiv, ${legacy.length})`}
      hint="Historische Varianten aus dem alten Datenmodell — nur zur Ansicht. Bestand wird über die Varianten oben und die Stock-Engine geführt.">
      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
        <div className="grid grid-cols-[1fr_90px_70px_1fr] gap-2 px-3 py-2 bg-slate-100 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
          <span>Name / Wert</span><span className="text-right">Einheit</span><span className="text-right">Bestand</span><span>Bild</span>
        </div>
        <div className="divide-y divide-slate-100">
          {legacy.map((v, i) => (
            <div key={i} className="grid grid-cols-[1fr_90px_70px_1fr] gap-2 px-3 py-2 text-sm text-slate-600 items-center">
              <span className="truncate">{v.value || '—'}</span>
              <span className="text-right tabular-nums">{v.unit_quantity ?? '—'}</span>
              <span className="text-right tabular-nums">{v.stock ?? '—'}</span>
              <span className="truncate text-[11px] font-mono text-slate-400">{v.image || '—'}</span>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
